import { Service } from '../config'
import { removePropertyEmpty } from '@/utils/index'

class UsersService extends Service {
  path = 'usuario'

  async get(params: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async reprove(params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `/reprovar`,
      params
    )
    return httpResponse
  }

  async download(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async GetSurveyorUsers(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/obterUsuariosVistoriadores`,
      {
        params: removePropertyEmpty(params)
      }
    )
    return httpResponse
  }

  async multipleActive(payload: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `/ativarLote`,
      payload
    )
    return httpResponse
  }

  async multipleInactive(payload: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `/inativarLote`,
      payload
    )
    return httpResponse
  }

  async valuationCompany(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/empresasviculadas`,
      { params }
    )
    return httpResponse
  }

  async getRequestingUsers(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/obterusuariossolicitantes`,
      { params }
    )
    return httpResponse
  }

  async getPerfis() {
    const httpResponse = await this.httpClient.get(`${this.path}/obterperfis`)
    return httpResponse
  }
}

export const usersService = new UsersService()
